import { messages } from '../messages';

export const HOME_SEARCH_TABS = [
  {
    id: 0,
    label: messages.studies,
  },
] as const;
